import * as React from "react";
import { useHistory } from "react-router";

import {
  OverviewSubtitle,
  OverviewTitle,
  OverviewTitleWithSubtitleWrapper,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import { PopupButton } from "../../../components/Forms/Base/Buttons";
import OverlaySpinner from "../../../components/Loaders/OverlaySpinner";
import * as SharedStyles from "../../../components/sharedStyles";
import { useAllPermissionCheck } from "../../../store/base";

import { useConfigCenter } from "../../../store/configcenter";

import PageTitle from "../../Layouts/PageTitle/PageTitle";

export default () => {
  const { push } = useHistory();

  const [configCenter] = useConfigCenter();

  const canEditConfigCenter = useAllPermissionCheck([
    "view_can_configcenter",
    "change_can_configcenter",
  ]);

  const goToEdit = () => {
    push(`/configcenter/general/gdpr-cleaning/edit`);
  };

  const breadCrumbs = [
    {
      label: "GDPR-Rensning",
      url: "/configcenter/general/gdpr-cleaning",
    },
  ];

  let actions = [];

  if (canEditConfigCenter)
    actions.push({
      name: "Redigera",
      onClick: () => goToEdit(),
    });

  return (
    <SharedStyles.BareLayoutWrapper fillWidth>
      {!configCenter && <OverlaySpinner />}
      <SharedStyles.BareLayoutTitleWrapper>
        <PageTitle title="GDPR-Rensning" breadCrumbs={breadCrumbs} />
      </SharedStyles.BareLayoutTitleWrapper>

      <SharedStyles.DetailPageBox>
        <OverviewTitleWrapper>
          <OverviewTitle>GDPR-Rensning</OverviewTitle>
          {actions?.length > 0 && (
            <PopupButton title="Hantera" actions={actions} />
          )}
        </OverviewTitleWrapper>

        <SharedStyles.InnerBox style={{ marginBottom: 12 }}>
          <OverviewTitleWrapper>
            <OverviewTitleWithSubtitleWrapper>
              <OverviewTitle small>
                Automatisk anonymisering av tidigare hyresgäster
              </OverviewTitle>
              <OverviewSubtitle>
                Om detta värde är satt kommer systemet automatiskt att
                anonymisera tidigare hyresgäster så många dagar efter avtalets
                utgång som är angivet.
              </OverviewSubtitle>
            </OverviewTitleWithSubtitleWrapper>
          </OverviewTitleWrapper>
          <SharedStyles.InnerBox>
            {configCenter?.tenant_anonymization_grace_period
              ? `Hyresgäster anonymiseras efter ${configCenter?.tenant_anonymization_grace_period} dagar`
              : "Anonymiseras ej automatiskt"}
          </SharedStyles.InnerBox>
        </SharedStyles.InnerBox>

        <SharedStyles.InnerBox style={{ marginBottom: 12 }}>
          <OverviewTitleWrapper>
            <OverviewTitleWithSubtitleWrapper>
              <OverviewTitle small>
                Automatisk radering av tidigare hyresgäster
              </OverviewTitle>
              <OverviewSubtitle>
                Om detta värde är satt kommer systemet automatiskt att radera
                tidigare hyresgäster så många dagar efter avtalets utgång som är
                angivet.
              </OverviewSubtitle>
            </OverviewTitleWithSubtitleWrapper>
          </OverviewTitleWrapper>
          <SharedStyles.InnerBox>
            {configCenter?.tenant_deletion_grace_period
              ? `Hyresgäster raderas efter ${configCenter?.tenant_deletion_grace_period} dagar`
              : "Raderas ej automatiskt"}
          </SharedStyles.InnerBox>
        </SharedStyles.InnerBox>
      </SharedStyles.DetailPageBox>
    </SharedStyles.BareLayoutWrapper>
  );
};
